import createReducer from 'utils/createReducer';
import {
  UPDATE_BASE_PACKAGES,
  UPDATE_CUSTOM_PACKAGES,
  SET_PACKAGES_LOADING,
  SHOW_CREATE_PACKAGE_MODAL,
  SHOW_EDIT_PACKAGE_MODAL,
  SET_PACKAGE_EDITOR_LOADING,
  SET_PACKAGE_EDITOR_ERROR,
  SHOW_DELETE_CONFIRMATION,
  SET_DELETE_LOADING,
  UPDATE_TERRITORIES,
  UPDATE_LEAD_SOURCES,
  UPDATE_BONUS_SUBSCRIPTION_TYPES,
  BILLING_PACKAGE_LOG_SET_SHOWN,
  BILLING_PACKAGE_LOG_SET_DATA,
  BILLING_PACKAGE_LOG_SET_IS_LOADING,
  BILLING_PACKAGE_LOG_SET_ERRORS,
} from './actionTypes';

const initialState = {
  basePackages: [],
  customPackages: [],
  territories: [],
  leadSources: [],
  bonusSubscriptionTypes: [],
  isLoading: false,
  editor: {
    isOpen: false,
    isEditMode: false,
    editingPackage: null,
    isLoading: false,
    errorMessage: null,
    errors: [],
  },
  deleteConfirmation: {
    isOpen: false,
    isLoading: false,
    packageToDelete: null,
  },
  log: {
    shown: false,
    isLoading: false,
    data: [],
    paging: {
      page: 1,
      size: 20,
      total: 0,
    },
    errors: [],
  },
};

const updateBasePackages = (state, action) => ({
  ...state,
  basePackages: action.payload,
});

const updateCustomPackages = (state, action) => ({
  ...state,
  customPackages: action.payload,
});

const setPackagesLoading = (state, action) => ({
  ...state,
  isLoading: action.payload,
});

const showCreatePackageModal = (state, action) => ({
  ...state,
  editor: {
    ...state.editor,
    isOpen: action.payload.shown,
    isEditMode: false,
    editingPackage: null,
    errorMessage: null,
    errors: [],
  },
});

const showEditPackageModal = (state, action) => ({
  ...state,
  editor: {
    ...state.editor,
    isOpen: action.payload.shown,
    isEditMode: true,
    editingPackage: action.payload.packageData,
    errorMessage: null,
    errors: [],
  },
});

const setPackageEditorLoading = (state, action) => ({
  ...state,
  editor: {
    ...state.editor,
    isLoading: action.payload,
  },
});

const setPackageEditorError = (state, action) => ({
  ...state,
  editor: {
    ...state.editor,
    errorMessage: action.payload ? action.payload.message : null,
    errors: (action.payload && action.payload.errors) || [],
  },
});

const showDeleteConfirmation = (state, action) => ({
  ...state,
  deleteConfirmation: {
    ...state.deleteConfirmation,
    isOpen: action.payload.shown,
    packageToDelete: action.payload.packageData,
  },
});

const setDeleteLoading = (state, action) => ({
  ...state,
  deleteConfirmation: {
    ...state.deleteConfirmation,
    isLoading: action.payload,
  },
});

const updateTerritories = (state, action) => ({
  ...state,
  territories: action.payload,
});

const updateLeadSources = (state, action) => ({
  ...state,
  leadSources: action.payload,
});

const updateBonusSubscriptionTypes = (state, action) => ({
  ...state,
  bonusSubscriptionTypes: action.payload,
});

const setLogModalShown = (state, action) => ({
  ...state,
  log: {
    ...state.log,
    shown: action.payload.shown,
  },
});

const setLogData = (state, action) => ({
  ...state,
  log: {
    ...state.log,
    data: action.payload.data,
    paging: action.payload.paging,
  },
});

const setLogIsLoading = (state, action) => ({
  ...state,
  log: {
    ...state.log,
    isLoading: action.payload.isLoading,
  },
});

const setLogErrors = (state, action) => ({
  ...state,
  log: {
    ...state.log,
    errors: action.payload.errors,
  },
});

export default createReducer(initialState, {
  [UPDATE_BASE_PACKAGES]: updateBasePackages,
  [UPDATE_CUSTOM_PACKAGES]: updateCustomPackages,
  [SET_PACKAGES_LOADING]: setPackagesLoading,
  [SHOW_CREATE_PACKAGE_MODAL]: showCreatePackageModal,
  [SHOW_EDIT_PACKAGE_MODAL]: showEditPackageModal,
  [SET_PACKAGE_EDITOR_LOADING]: setPackageEditorLoading,
  [SET_PACKAGE_EDITOR_ERROR]: setPackageEditorError,
  [SHOW_DELETE_CONFIRMATION]: showDeleteConfirmation,
  [SET_DELETE_LOADING]: setDeleteLoading,
  [UPDATE_TERRITORIES]: updateTerritories,
  [UPDATE_LEAD_SOURCES]: updateLeadSources,
  [UPDATE_BONUS_SUBSCRIPTION_TYPES]: updateBonusSubscriptionTypes,
  [BILLING_PACKAGE_LOG_SET_SHOWN]: setLogModalShown,
  [BILLING_PACKAGE_LOG_SET_DATA]: setLogData,
  [BILLING_PACKAGE_LOG_SET_IS_LOADING]: setLogIsLoading,
  [BILLING_PACKAGE_LOG_SET_ERRORS]: setLogErrors,
});
